import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const process = require('../env');
const util = require('../utils/index');

const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}

export const loginApi = async (formValue) => {
  try{
      
      const response = await axios.post(`${process.env.URL}/check/login`, formValue);
      const user = response.data
      if (response.status === 200){
        
        sessionStorage.setItem("user", JSON.stringify(user))
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const registrarADMApi = async (formValue) => {
  try{
  
      const response = await axios.post(`${process.env.URL}/administrator/createAdministrator`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarADMApi = async () => {
  try{
      const response = await axios.get(`${process.env.URL}/administrator/getAdministrators`, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     //toast.error(e.response.data['message']);
     console.log(e);
    }
  return false;
}

export const pegarADMApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/administrator/getAdministratorByID`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const atualizarADMApi = async (formValue) => {
  try{
      const response = await axios.put(`${process.env.URL}/administrator/updateAdministrator`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const excluirADMApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/administrator/deleteAdministrator`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);

    }
  return false;
}